/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    Carriers,
    CarriersFromJSON,
    CarriersFromJSONTyped,
    CarriersToJSON,
    CodeAndLabel,
    CodeAndLabelFromJSON,
    CodeAndLabelFromJSONTyped,
    CodeAndLabelToJSON,
    FareBasisCode,
    FareBasisCodeFromJSON,
    FareBasisCodeFromJSONTyped,
    FareBasisCodeToJSON,
} from './';

/**
 * 
 * @export
 * @interface GlobalFilterRuleListQuery
 */
export interface GlobalFilterRuleListQuery {
    /**
     * 
     * @type {boolean}
     * @memberof GlobalFilterRuleListQuery
     */
    showDisabled?: boolean;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof GlobalFilterRuleListQuery
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {number}
     * @memberof GlobalFilterRuleListQuery
     */
    distributionChannel?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GlobalFilterRuleListQuery
     */
    agency?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GlobalFilterRuleListQuery
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GlobalFilterRuleListQuery
     */
    relevance?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GlobalFilterRuleListQuery
     */
    origin?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalFilterRuleListQuery
     */
    originIsCityCode?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GlobalFilterRuleListQuery
     */
    destination?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalFilterRuleListQuery
     */
    destinationIsCityCode?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GlobalFilterRuleListQuery
     */
    marketingFlightNumbers?: string | null;
    /**
     * 
     * @type {FareBasisCode}
     * @memberof GlobalFilterRuleListQuery
     */
    fareBasis?: FareBasisCode;
    /**
     * 
     * @type {CodeAndLabel}
     * @memberof GlobalFilterRuleListQuery
     */
    fareType?: CodeAndLabel;
    /**
     * 
     * @type {Carriers}
     * @memberof GlobalFilterRuleListQuery
     */
    carriers?: Carriers;
    /**
     * 
     * @type {string}
     * @memberof GlobalFilterRuleListQuery
     */
    bookingClass?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalFilterRuleListQuery
     */
    showDeleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalFilterRuleListQuery
     */
    orderByRelevanceAscending?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GlobalFilterRuleListQuery
     */
    offset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GlobalFilterRuleListQuery
     */
    limit?: number | null;
}

export function GlobalFilterRuleListQueryFromJSON(json: any): GlobalFilterRuleListQuery {
    return GlobalFilterRuleListQueryFromJSONTyped(json, false);
}

export function GlobalFilterRuleListQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlobalFilterRuleListQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'showDisabled': !exists(json, 'showDisabled') ? undefined : json['showDisabled'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'distributionChannel': !exists(json, 'distributionChannel') ? undefined : json['distributionChannel'],
        'agency': !exists(json, 'agency') ? undefined : json['agency'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'relevance': !exists(json, 'relevance') ? undefined : json['relevance'],
        'origin': !exists(json, 'origin') ? undefined : json['origin'],
        'originIsCityCode': !exists(json, 'originIsCityCode') ? undefined : json['originIsCityCode'],
        'destination': !exists(json, 'destination') ? undefined : json['destination'],
        'destinationIsCityCode': !exists(json, 'destinationIsCityCode') ? undefined : json['destinationIsCityCode'],
        'marketingFlightNumbers': !exists(json, 'marketingFlightNumbers') ? undefined : json['marketingFlightNumbers'],
        'fareBasis': !exists(json, 'fareBasis') ? undefined : FareBasisCodeFromJSON(json['fareBasis']),
        'fareType': !exists(json, 'fareType') ? undefined : CodeAndLabelFromJSON(json['fareType']),
        'carriers': !exists(json, 'carriers') ? undefined : CarriersFromJSON(json['carriers']),
        'bookingClass': !exists(json, 'bookingClass') ? undefined : json['bookingClass'],
        'showDeleted': !exists(json, 'showDeleted') ? undefined : json['showDeleted'],
        'orderByRelevanceAscending': !exists(json, 'orderByRelevanceAscending') ? undefined : json['orderByRelevanceAscending'],
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function GlobalFilterRuleListQueryToJSON(value?: GlobalFilterRuleListQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'showDisabled': value.showDisabled,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'distributionChannel': value.distributionChannel,
        'agency': value.agency,
        'description': value.description,
        'relevance': value.relevance,
        'origin': value.origin,
        'originIsCityCode': value.originIsCityCode,
        'destination': value.destination,
        'destinationIsCityCode': value.destinationIsCityCode,
        'marketingFlightNumbers': value.marketingFlightNumbers,
        'fareBasis': FareBasisCodeToJSON(value.fareBasis),
        'fareType': CodeAndLabelToJSON(value.fareType),
        'carriers': CarriersToJSON(value.carriers),
        'bookingClass': value.bookingClass,
        'showDeleted': value.showDeleted,
        'orderByRelevanceAscending': value.orderByRelevanceAscending,
        'offset': value.offset,
        'limit': value.limit,
    };
}


